module.exports = __webpack_public_path__ + "assets/img/mecha-btn-daa52dba.png";